import { render, staticRenderFns } from "./WsCuratorsManagement.vue?vue&type=template&id=02dd4a65&scoped=true"
import script from "./WsCuratorsManagement.vue?vue&type=script&lang=js"
export * from "./WsCuratorsManagement.vue?vue&type=script&lang=js"
import style0 from "./WsCuratorsManagement.vue?vue&type=style&index=0&id=02dd4a65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02dd4a65",
  null
  
)

export default component.exports